import type { TransitionComponentProps } from 'util/react-transition-component/types/transitionComponent.types';
import type { ButtonType } from '../../../util/cta/cta.data';

export type PlayIconRef = HTMLElement;

export const defaultButtonType: ButtonType = 'button';
export const defaultButtonSize: ButtonSize = 'small';

export const buttonSizes = ['small', 'medium'] as const;

export type ButtonSize = (typeof buttonSizes)[number];

export type PlayIconProps = {
  size?: ButtonSize;

  isPlaying: boolean;
} & TransitionComponentProps;
